/**
 * Runtime debug switches.
 *
 * Dev is always verbose. On a staging build, set
 * `localStorage.setItem('debugWhatsNew', '1')` to turn the What's New diagnostics
 * on without rebuilding.
 */

export function isWhatsNewDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return localStorage.getItem("debugWhatsNew") === "1";
  } catch {
    // Storage can be blocked entirely (privacy mode, embedded contexts).
    return false;
  }
}
